import env from "../Config/env";

/**
 * Base para as URLs públicas GERADAS (link de pagamento / link de hotel).
 * Usa REACT_APP_PUBLIC_BASE_URL quando setado (domínio público dedicado);
 * senão, cai no origin atual (comportamento padrão — mesmo domínio).
 */
export const publicBaseUrl = () => {
	const origin = (typeof window !== "undefined" && window.location) ? window.location.origin : "";
	return String(env.PUBLIC_BASE_URL || origin).replace(/\/$/, "");
};

/**
 * True quando o app está rodando no domínio público dedicado
 * (REACT_APP_PUBLIC_HOST). Nesse host, só as rotas públicas são servidas.
 * Vazio (default) → sempre false → comportamento atual (tudo no mesmo domínio).
 */
export const isPublicHost = () =>
	!!env.PUBLIC_HOST && typeof window !== "undefined" && window.location.hostname === env.PUBLIC_HOST;
